module.exports = __webpack_public_path__ + "cd40fe3a982a8e30a12b21a13a588802.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1146
// module chunks = 0